export const MOBILE_WIDTH = 800;
export const DESKTOP_CONTAINER_WIDTH = 1400;
